import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import DashboardLayout from "components/layout/DashboardLayout";
// Eliminado: import AuthenticationGuard
import NotFound from "pages/NotFound";
import LoginPage from './pages/login';
import ResetPassword from './pages/login/ResetPassword';
import APIConfiguration from './pages/api-configuration';
import Dashboard from './pages/dashboard';
import UploadHistory from './pages/upload-history';
import BulkUpload from './pages/bulk-upload';
import ConfirmEmail from './pages/register/ConfirmEmail';
import AWSConnection from './pages/aws-database-connection';
import DatabaseFieldSelection from './pages/database-field-selection';
import DataExportGenerator from './pages/data-export-generator';
import ExcelValidator from './components/ExcelValidator';
import AdminUsers from './pages/admin-users';
import PriceUpdater from './pages/price-updater';
import McoClassifier from './pages/mco-classifier';
import McoAdminGuard from './pages/mco-classifier/AdminGuard';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/confirm-email" element={<ConfirmEmail />} />

          <Route element={<DashboardLayout />}>
            <Route path="/" element={<APIConfiguration />} />
            <Route path="/api-configuration" element={<APIConfiguration />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/upload-history" element={<UploadHistory />} />
            <Route path="/bulk-upload" element={<BulkUpload />} />
            <Route path="/aws-database-connection" element={<AWSConnection />} />
            <Route path="/database-field-selection" element={<DatabaseFieldSelection />} />
            <Route path="/data-export-generator" element={<DataExportGenerator />} />
            <Route path="/excel-validator" element={<ExcelValidator />} />
            <Route path="/price-updater" element={<PriceUpdater />} />
            <Route path="/admin/users" element={<AdminUsers />} />
            <Route path="/admin/mco-classifier" element={<McoAdminGuard><McoClassifier /></McoAdminGuard>} />
          </Route>

          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
